"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Icon;

var _react = _interopRequireDefault(require("react"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var capitalize = function capitalize(str) {
  return str && str.charAt(0).toUpperCase() + str.slice(1);
};

function Icon(_ref) {
  var _classnames;

  var className = _ref.className,
      onClick = _ref.onClick,
      icon = _ref.icon,
      prefix = _ref.prefix,
      fixedWidth = _ref.fixedWidth,
      spin = _ref.spin,
      pulse = _ref.pulse,
      size = _ref.size,
      x = _ref.x,
      frikin = _ref.frikin,
      style = _ref.style;
  var iconClass = (0, _classnames2.default)('frikin-icon', prefix, "fa-".concat(icon), (_classnames = {}, _defineProperty(_classnames, "icon-".concat(capitalize(icon)), frikin || prefix === 'frikin'), _defineProperty(_classnames, 'fa-fw', fixedWidth), _defineProperty(_classnames, 'fa-spin', spin), _defineProperty(_classnames, 'fa-pulse', pulse), _defineProperty(_classnames, 'fa-xs', !x && size === 'small'), _defineProperty(_classnames, 'fa-sm', !x && size === 'medium'), _defineProperty(_classnames, 'fa-lg', !x && size === 'large'), _defineProperty(_classnames, "fa-".concat(x, "x"), !!x), _classnames), className);
  return /*#__PURE__*/_react.default.createElement("i", {
    style: style,
    className: iconClass,
    onClick: onClick
  });
}

Icon.propTypes = {
  className: _propTypes.default.string,
  onClick: _propTypes.default.func,
  prefix: _propTypes.default.oneOf(['fas', 'far', 'fal', 'fab', 'frikin']),
  style: _propTypes.default.object,
  spin: _propTypes.default.bool,
  pulse: _propTypes.default.bool,
  frikin: _propTypes.default.bool,
  fixedWidth: _propTypes.default.bool,
  icon: _propTypes.default.string.isRequired,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  x: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]) // between 2 and 10

};
Icon.defaultProps = {
  onClick: function onClick() {},
  prefix: 'fas',
  style: {}
};